(function() {
  function initRotatingBar() {
    // Select all containers (Mobile and Desktop)
    const containers = document.querySelectorAll('.notification-container');
    
    containers.forEach(container => {
      const items = container.querySelectorAll('.notification-item');
      if (!container || items.length <= 1) return;

      let currentIndex = 0;
      const height = 38;

      setInterval(() => {
        currentIndex++;
        if (currentIndex >= items.length) {
          currentIndex = 0;
        }
        container.style.transform = `translateY(-${currentIndex * height}px)`;
      }, 4000); // Rotates every 4 seconds
    });
  }

  // Run on load
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initRotatingBar();
  } else {
    document.addEventListener('DOMContentLoaded', initRotatingBar);
  }
})();